(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jugre-home-products"]) return;
  try {
    
  function placeJugreHomeProducts() {
    const productSection = document.querySelector('[data-jugre-home-products]');
    if (!productSection) return;

    const sampleProductSection = document.querySelector('[id*="product_list_themegen"]');
    if (sampleProductSection) {
      sampleProductSection.insertAdjacentElement('beforebegin', productSection);
      sampleProductSection.hidden = true;
      return;
    }

    const marquee = document.querySelector('[id*="marquee"]');
    if (marquee && marquee.nextElementSibling !== productSection) {
      marquee.insertAdjacentElement('afterend', productSection);
    }
  }

  document.addEventListener('DOMContentLoaded', placeJugreHomeProducts);
  document.addEventListener('shopify:section:load', placeJugreHomeProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
